import { PublishDraft, PublishDraftToken } from "$src/application/projects/sub/drafts/commands/PublishDraft";
import { DraftIdentifier } from "$src/domain/projects/drafts/DraftIdentifier";
import { useMutation, useQueryClient } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

export async function publishDraft(groupStoreId: number, projectId: number)
    : Promise<DraftIdentifier> {

    const query = container.resolve<PublishDraft>(PublishDraftToken);
    return query.execute(groupStoreId, projectId);
}

export function usePublishDraft() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ groupStoreId, projectId }: 
            { groupStoreId: number, projectId: number }
        ) => publishDraft(groupStoreId, projectId),
        {
            onSuccess: (data, variables) => {
                queryClient.invalidateQueries(['project-customer', data.groupStoreId, data.projectId], { refetchActive: true });
            },
        }
    );
}